import React from 'react';
import { useRecoilValue } from 'recoil';
import { Carousel, CarouselItem } from '@vodacomsa/ns-react-components';
import styles from './ApplyProduct.module.css';
import { Colors, Fonts } from '../../../constants';
import { useIsSuperMobile, productListFetch, userFirstName } from '../../../recoil';
import { ProductContainer } from '../../../components';

export const ApplyProduct = () => {

  const isSuperMobile = useRecoilValue(useIsSuperMobile);
  const productList = useRecoilValue(productListFetch({}));
  const userName = useRecoilValue(userFirstName);

  const stylesRef = {
    main: {
      textAlign: 'center'
    },
    productContainer: {
      display: 'flex',
      flexFlow: 'wrap',
      backgroundColor: Colors.GreyScale1,
      color: Colors.GreyScale13,
      justifyContent: 'flex-start'
    },
    h1: {
      fontFamily: Fonts.Roboto,
      fontWeight: '500',
      fontSize: '30px',
      lineHeight: '36px',
      letterSpacing: '-3%',
      textAlign: 'center',
      margin: '40px 20px 30px'
    }
  };

  const renderProducts = (products) => {

    if (!products?.length) {
      return null;
    }

    return isSuperMobile ? (
      <div className={styles.carouselContainer}>
        <Carousel dots className={styles.carouselCustom}>
          {products.map((product) => (
            <CarouselItem key={product.productId} className={styles.carouselItem}>
              <ProductContainer
                showProductCriteria={false}
                showApplyButton={true}
                {...product}
              />
            </CarouselItem>
          ))}
        </Carousel>
      </div>
    ) : (
      <div style={stylesRef.productContainer}>
        {products.map((product) => (
          <ProductContainer
            key={product.productId}
            showProductCriteria={false}
            showApplyButton={true}
            {...product}
          />
        ))}
      </div>
    );
  };

  return (
    <div style={stylesRef.main}>
      <h2 className={styles.usernameContainer}>{userName ? `Hi ${userName}` : ''}</h2>
      <h1 className={styles.pageHeader}>{'A full suite of business solutions to grow your business'}</h1>
      <p className={styles.pageContent}>Whether you’re growing your team, investing in equipment, or jumping on your next big opportunity, our flexible business lending solutions are built to back you. Get the funding you need, with options that fit your pace, priorities, and ambition.</p>
      {renderProducts(productList?.nonMatchingProducts)}
    </div>
  );
};